module.exports = new __parcel__URL__("choose_3.f0d44fb7.png").toString();